/* ───────────── CONFIG ───────────── */
const GEO_ENDPOINT =
  'https://api.ipgeolocation.io/ipgeo?fields=state_code';

const STATE_COOKIE = 'selectedState';
const STATE_DAYS   = 365;

const TIP_COOKIE   = 'stateTooltipDismissed';
const TIP_DAYS     = 30;

const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS',
  'KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY',
  'NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV',
  'WI','WY'
];

/* ─────────── SHARED HELPERS / GLOBAL OBJECT ────────── */
window.StateSelect = window.StateSelect || {};

if (!StateSelect.setCookie) {
  StateSelect.setCookie = (name, value, days = 365) => {
    let exp = '';
    if (days) {
      const d = new Date();
      d.setTime(d.getTime() + days * 864e5);
      exp = '; expires=' + d.toUTCString();
    }
    document.cookie = `${name}=${encodeURIComponent(value)}${exp}; path=/; SameSite=Lax`;
  };

  StateSelect.getCookie = (name) => {
    const n = `${name}=`;
    return (
      document.cookie
        .split(';')
        .map((c) => c.trim())
        .find((c) => c.startsWith(n))
        ?.substring(n.length) || ''
    );
  };
}

/* ========= Geo-IP Detect if no Cookie Set ========= */
(async () => {
  if (StateSelect.getCookie(STATE_COOKIE)) return;

  try {
    const res  = await fetch(GEO_ENDPOINT, { cache: 'no-store' });
    if (!res.ok) throw new Error('Geo-IP request failed');

    let code = (await res.json()).state_code?.replace(/^US-/, '') || '';

    if (US_STATES.includes(code)) {
      StateSelect.setCookie(STATE_COOKIE, code, STATE_DAYS);
      StateSelect.updateHeaderText?.(code);
      StateSelect.maybeShowTooltip?.(code);
      StateSelect.applyProductRestrictions?.(code);
    } else {
    StateSelect.maybeShowTooltip?.('', true);
      }
    } catch (err) {
    console.info('Geo-IP unavailable:', err);
  }
})();

/* ───────────── Tooltip Display (via cookie) ───────────── */
function injectTooltip(stateCode = '', isFallback = false) {
  if (StateSelect.getCookie(TIP_COOKIE)) return;

  const trigger = document.querySelector('[aria-controls="StateDrawer"]');
  if (!trigger) return;

  const labelState = stateCode || 'your state?';

  // ✨ CONDITIONAL COPY ✨
  const header = isFallback ? 'Shipping Location' : `Ship to ${labelState}`;
  const text = isFallback
    ? 'We ship to all 50 US states. Please select your state so we can show you products available there.'
    : 'Sending your order somewhere else? Select the correct state to view products available there.';

  const tip = document.createElement('div');
  tip.className = 'state-tooltip';
  tip.innerHTML = `
    <p class="tooltip-header">${header}</p>
      <button type="button" class="tip-close" aria-label="Close tooltip">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false"
          class="icon icon-close icon--{{ size | default: 'medium' }}"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path d="M18.75 5.13496L5.25 18.8544" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18.75 18.8544L5.25 5.13496" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    <p class="tooltip-text">${text}</p>
  `;

  trigger.appendChild(tip);

  tip.querySelector('.tip-close').addEventListener('click', (e) => {
    e.stopPropagation();
    tip.remove();
    StateSelect.setCookie(TIP_COOKIE, '1', TIP_DAYS);
  });
}

//////
// function injectTooltip(stateCode = '') {
//   if (StateSelect.getCookie(TIP_COOKIE)) return;

//   const trigger = document.querySelector('[aria-controls="StateDrawer"]');
//   if (!trigger) return;

//   const labelState = stateCode || 'your state?';

//   const tip = document.createElement('div');
//   tip.className = 'state-tooltip';
//   tip.innerHTML = `
//     <p class="tooltip-header">Ship to ${labelState}</p>
//     <button type="button" class="tip-close" aria-label="Close tooltip">✕</button>
//     <p class="tooltip-text">Sending your order somewhere else? Select a different state to view products available there.</p>
//   `;

//   trigger.appendChild(tip);

//   tip.querySelector('.tip-close').addEventListener('click', (e) => {
//     e.stopPropagation();
//     tip.remove();
//     StateSelect.setCookie(TIP_COOKIE, '1', TIP_DAYS);
//   });
// }

/* ───────────── Product-card overlay ───────────── */
function restrictCards(state) {
  document
    .querySelectorAll('.product-card[data-excluded-states]')
    .forEach((card) => {
      const restricted = card.dataset.excludedStates
        .split(',')
        .map((s) => s.trim());
      if (!restricted.includes(state)) return;

      const wrap = card.querySelector('.product-card__image-wrapper');
      if (!wrap) return;

      wrap.style.position = 'relative';
      wrap.insertAdjacentHTML(
        'beforeend',
        `
        <div class="restricted-overlay">
          <div class="restricted-overlay-content">
            Not available in ${state}.<br>
            <a href="#" aria-controls="StateDrawer" aria-label="Select your state">Change state</a>
            <svg width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.75 4.5L6 8.25L2.25 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>`
      );

      const link = wrap.querySelector('a[aria-controls="StateDrawer"]');
      if (link) {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const drawer = document.getElementById('StateDrawer');
          if (drawer.show) {
            drawer.show();
          } else if (drawer.open) {
            drawer.open();
          }
        });
      }
    });
}

/* expose helpers for state-drawer.js */
StateSelect.maybeShowTooltip         = injectTooltip;
StateSelect.applyProductRestrictions = restrictCards;

/* ───────────── Run on every page load ───────────── */
document.addEventListener('DOMContentLoaded', () => {
  const state = StateSelect.getCookie(STATE_COOKIE);
  if (state) restrictCards(state);
  injectTooltip(state);
});